import { useHistory } from 'react-router-dom';
import { generateUrl, generateUrlWithQuery } from '../../util';
import { Button } from 'reactstrap';
import { ROUTES } from '../../../constants/routes';
import { ActionModal } from './ActionModal';
import React, { useState } from 'react';
import { UniversalTrackerPlain } from '../../../types/universalTracker';
import { getUtrFrameworkNames, getUtrStandardNames } from '../../../constants/standards-frameworks';
import { QUESTION, SURVEY } from '@constants/terminology';
import { UniversalTrackerModalServiceUtrv } from '@g17eco/types/universalTrackerValue';
import { SimpleTooltip } from '@g17eco/molecules/simple-tooltip';
import { navigateToQuestionFromUtrv } from './navigateToQuestion';

type LinkText = string | React.JSX.Element;

interface Props {
  text: LinkText;
  initiativeId?: string;
  surveyId?: string;
  utrv?: Pick<UniversalTrackerModalServiceUtrv, '_id' | 'compositeData' | 'disaggregation'>;
  btnClass?: string;
  utr?: Pick<UniversalTrackerPlain, 'type' | 'name' | 'alternatives' | 'tags'>;
  tooltip: LinkText;
}

const defaultModal = { isOpen: false, modalText: '', actionText: '', actionUrl: '' };

export const UtrvLink = (props: Props) => {
  const { initiativeId, surveyId, text, utrv, btnClass = '', utr, tooltip } = props;

  const history = useHistory();
  const [modal, setModal] = useState(defaultModal);

  if (!initiativeId) {
    return <>{text}</>;
  }

  const handleClick = () => {
    if (!utrv) {
      // if have latest survey with current period, open survey scope modal
      if (surveyId) {
        const utrFrameworks = getUtrFrameworkNames(utr);
        const utrStandards = getUtrStandardNames(utr);

        setModal({
          isOpen: true,
          modalText: `The selected ${SURVEY.SINGULAR} does not have this ${QUESTION.SINGULAR} in Scope`,
          actionText: `Update ${SURVEY.SINGULAR} scope`,
          actionUrl: generateUrlWithQuery(
            ROUTES.COMPANY_TRACKER_SURVEY,
            { initiativeId, surveyId, page: 'scope' },
            { search: [...utrFrameworks, ...utrStandards].join(',') }
          ),
        });
        return;
      }
      // if no survey, open survey create modal
      setModal({
        isOpen: true,
        modalText: `There are no ${SURVEY.PLURAL} for the required period`,
        actionText: `Create a ${SURVEY.SINGULAR}`,
        actionUrl: `${generateUrl(ROUTES.COMPANY_TRACKER_LIST, { initiativeId })}/create`,
      });
      return;
    }

    // Reuse navigation logic
    navigateToQuestionFromUtrv({ initiativeId, utrv, history });
  };

  const toggleModal = () => setModal({ ...defaultModal, isOpen: false });

  return (
    <>
      <ActionModal {...{ ...modal, toggle: toggleModal }} />
      <div className='mw-100 d-inline-block overflow-hidden pe-1'>
        <SimpleTooltip text={tooltip}>
          <Button onClick={handleClick} color='link' className={`text-truncate p-0 ${btnClass}`}>
            {text}
          </Button>
        </SimpleTooltip>
      </div>
    </>
  );
};
